<template lang="pug">
  .box-warning
    h2 Не удалось загрузить данные
    p Подождите пару минут и попробуйте загрузить страницу еще раз
    button.btn(
      v-on:click="onClickReload"
      v-bind:disabled="disabled"
    ) Перезагрузить страницу
</template>

<script>
export default {
  data() {
    return {
      disabled: false
    };
  },

  methods: {
    onClickReload() {
      this.disabled = true;
      this.$emit('reload');
      setTimeout(() => {
        this.disabled = false;
      }, 3000);
    }
  }
};
</script>
